import React, { useContext } from 'react'

import { SimpleMapProps } from '@/components/shared/map/components/simple-map'
import ListingsContext from '@/context/listings'

import styles from './styles.module.scss'

interface MapProps extends SimpleMapProps {
    isMiniMap?: boolean
}

const StaticImageMap: React.FC<MapProps> = () => {
    const { selectors: listingsSelectors } = useContext(ListingsContext)
    const { seatViewObject } = listingsSelectors
    const altText: string = seatViewObject?.mapTitle ? `${seatViewObject.mapTitle} Venue Map` : 'Venue Map'

    return seatViewObject?.staticMapUrl ? (
        <div className={styles.staticMapWrapper}>
            <img src={seatViewObject.staticMapUrl} alt={altText} className={styles.staticMap} />
        </div>
    ) : null
}

export default StaticImageMap
